import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import { AREAS, LOCATIONS } from "@/data/site";
import { Reveal } from "@/components/common/Reveal";

export const AreasServed = () => (
  <section data-testid="areas-section" className="bg-white">
    <div className="mx-auto max-w-[1440px] px-6 py-24 md:px-12 md:py-32 lg:px-20 lg:py-40">
      <div className="grid gap-12 lg:grid-cols-[0.9fr_1.1fr] lg:gap-20">
        <Reveal>
          <span className="text-sm font-semibold uppercase tracking-[0.2em] text-brand-blue">
            Areas We Serve
          </span>
          <h2 className="mt-5 font-display text-4xl font-semibold leading-[1.02] tracking-tight text-brand-dark md:text-5xl lg:text-6xl">
            Serving patients across <span className="italic text-brand-blue">Varanasi</span>
          </h2>
          <p className="mt-6 max-w-md text-brand-muted">
            Conveniently located in Paharia, our clinic welcomes patients from neighbourhoods all
            across the city. Explore our dedicated location pages for directions from your area.
          </p>
          <div className="mt-8 flex flex-wrap gap-2">
            {AREAS.map((a) => (
              <span
                key={a}
                className="inline-flex items-center gap-1.5 rounded-full border border-brand-line bg-brand-soft px-4 py-2 text-sm font-medium text-brand-dark"
              >
                <MapPin className="h-3.5 w-3.5 text-brand-blue" />
                {a}
              </span>
            ))}
          </div>
        </Reveal>

        <div className="grid gap-4 sm:grid-cols-2">
          {LOCATIONS.map((l, i) => (
            <Reveal key={l.slug} delay={(i % 2) * 0.08}>
              <Link
                to={`/${l.slug}`}
                data-testid={`area-card-${l.slug}`}
                className="group flex h-full flex-col justify-between rounded-2xl border border-brand-line p-7 transition-all duration-300 hover:-translate-y-1 hover:border-brand-blue/40 hover:bg-brand-soft"
              >
                <div>
                  <span className="text-xs font-semibold uppercase tracking-wider text-brand-green">
                    {l.distance}
                  </span>
                  <h3 className="mt-2 font-display text-2xl font-medium text-brand-dark">
                    Dentist in {l.area}
                  </h3>
                  <p className="mt-2 text-sm text-brand-muted">{l.short}</p>
                </div>
                <span className="mt-5 text-sm font-semibold text-brand-blue">View location →</span>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
